import { __assign } from "tslib";
import React from "react";
import onClickOutSide from "react-onclickoutside";
export function withOutsideClick(methodName) {
    // https://github.com/Pomax/react-onclickoutside#ie-does-not-support-classlist-for-svg-elements
    if (typeof SVGElement !== "undefined" &&
        !("classList" in SVGElement.prototype)) {
        Object.defineProperty(SVGElement.prototype, "classList", {
            get: function () {
                var _this = this;
                return {
                    contains: function (className) {
                        return _this.className.baseVal.split(" ").indexOf(className) !== -1;
                    },
                };
            },
        });
    }
    return function (WrappedComponent) {
        var Component = onClickOutSide(WrappedComponent, {
            handleClickOutside: function (instance) { return instance[methodName]; },
        });
        return (function (props) {
            return React.createElement(Component, __assign(__assign({}, props), { outsideClickIgnoreClass: "ignore-outside-click" }));
        });
    };
}
//# sourceMappingURL=with-outside-click.js.map